<template>
  <div class="query-form-panel">
    <el-form ref="ruleForm" :model="ruleForm" status-icon class="demo-ruleForm" label-width="100px">
      <el-row :gutter="24" style="width: 85%">
        <div v-for="(item, index) in fields" :key="item.id">
          <el-col
            class="form-item"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="8"
            v-if="(!showMore ? index <= 2 : index >= 0) && item.fieldType != 'PRICE_INPUT'"
          >
            <el-form-item :label="item.fieldName" :prop="item.fieldCode">
              <el-input
                clearable
                v-if="item.fieldType == 'INPUT'"
                v-model.trim="ruleForm[item.fieldCode]"
                type="text"
                autocomplete="off"
                :placeholder="'请输入' + item.fieldName"
              />
              <template v-if="item.fieldType == 'DYNAMIC_DEFINE'">
                <slot />
              </template>
              <template v-if="item.fieldType == 'PRICE_INPUT'">
                <el-row class="price-row">
                  <el-col :span="11">
                    <el-input
                      clearable
                      onkeyup="value=value.replace(/[^\d|^.]/g,'').replace(/(\d+)(\.?)(\d{0,2}).*$/g,'$1$2$3').replace(/^0+/, '0');if(value === '0'){value=1}"
                      @blur="ruleForm[item.fieldCode] = $event.target.value"
                      v-model.trim="ruleForm[item.fieldCode]"
                      type="text"
                      autocomplete="off"
                      placeholder="最小金额"
                      class="price-input"
                      ><i slot="suffix" class="price-font">{{ item.fieldUnit }}</i></el-input
                    >
                  </el-col>
                  <el-col :span="2" class="price-split">
                    <span>至</span>
                  </el-col>
                  <el-col :span="11">
                    <el-input
                      clearable
                      onkeyup="value=value.replace(/[^\d|^.]/g,'').replace(/(\d+)(\.?)(\d{0,2}).*$/g,'$1$2$3').replace(/^0+/, '0');if(value === '0'){value=1}"
                      @blur="ruleForm[item.fieldCodeMax] = $event.target.value"
                      v-model.trim="ruleForm[item.fieldCodeMax]"
                      type="text"
                      autocomplete="off"
                      placeholder="最大金额"
                      class="price-input"
                      ><i slot="suffix" class="price-font">{{ item.fieldUnit }}</i></el-input
                    >
                  </el-col>
                </el-row>
              </template>
              <el-date-picker
                class="date-range"
                v-if="item.fieldType == 'DATE_TIME_RANGE'"
                v-model="ruleForm[item.fieldCode]"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-date-picker
                class="date-range"
                v-if="item.fieldType == 'DATE_RANGE'"
                v-model="ruleForm[item.fieldCode]"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-select
                :no-data-text="item.noDataText"
                clearable
                v-if="item.fieldType == 'SELECT'"
                v-model="ruleForm[item.fieldCode]"
                placeholder="全部"
                style="width: 100%"
                @visible-change="(response) => selectClickHandle(response, item.fieldCode)"
                @change="() => changeHandle(item.fieldCode)"
                filterable
              >
                <el-option v-for="item in item.selectOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-cascader
              :ref='item.refKey'
                v-if="item.fieldType == 'CASCADER'"
                v-model="ruleForm[item.fieldCode]"
                placeholder="全部"
                :options="item.selectOptions"
                :props="item.props"
                clearable
                collapse-tags
                @change='(val)=>cascaderChange(val,item.refKey)'
              ></el-cascader>
              <el-autocomplete
                v-if="item.fieldType == 'AUTOCOMPLETE'"
                v-model="ruleForm[item.fieldCode]"
                  :fetch-suggestions="querySearchAsync"
                :placeholder="'请输入' + item.fieldName"
                clearable
                @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col
            class="form-item"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="8"
            v-if="(!showMore ? index <= 2 : index >= 0) && item.fieldType == 'PRICE_INPUT'"
          >
            <el-form-item :label="item.fieldName">
              <template>
                <el-row class="price-row">
                  <el-col :span="11">
                    <el-form-item :prop="item.fieldCode">
                      <el-input
                        clearable
                        onkeyup="value=value.replace(/[^\d|^.]/g,'').replace(/(\d+)(\.?)(\d{0,2}).*$/g,'$1$2$3').replace(/^0+/, '0')"
                        @blur="ruleForm[item.fieldCode] = $event.target.value"
                        v-model.trim="ruleForm[item.fieldCode]"
                        type="text"
                        autocomplete="off"
                        placeholder="最小金额"
                        class="price-input"
                        ><i slot="suffix" class="price-font">{{ item.fieldUnit }}</i></el-input
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" class="price-split">
                    <span>至</span>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item :prop="item.fieldCodeMax">
                      <el-input
                        clearable
                        onkeyup="value=value.replace(/[^\d|^.]/g,'').replace(/(\d+)(\.?)(\d{0,2}).*$/g,'$1$2$3').replace(/^0+/, '0');"
                        @blur="ruleForm[item.fieldCodeMax] = $event.target.value"
                        v-model.trim="ruleForm[item.fieldCodeMax]"
                        type="text"
                        autocomplete="off"
                        placeholder="最大金额"
                        class="price-input"
                        ><i slot="suffix" class="price-font">{{ item.fieldUnit }}</i></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <div class="right-content">
        <div class="btn-group">
          <el-button class="standard-btn" @click="submitForm">查询</el-button>
          <el-button class="simple-btn" @click="resetQuery">重置</el-button>
          <el-button type="text" class="show-more" @click="handleClickShowMore" v-if="fields.length > 3">
            {{ showMore ? '收起' : '展开' }}
            <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { resetForm } from '@/utils/common';
export default {
  mixins: [],
  data() {
    return {
      showMore: false
    };
  },
  props: ['ruleForm', 'fields','querySearchAsync'],
  components: {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  created() {},
  mounted() {
    /**
     * 对于下拉框组件，初始化option数据
     * 默认使用global
     * 示例:
     *  {
          id: 3,
          fieldName: "筑友状态",
          fieldCode: "state",
          fieldType: "SELECT",
          fieldDictClass:'buddy_invitation_state',
          fieldDictItem:'',//字典多层
          fieldDictApi:'tenant',
          selectOptions: [],
          fieldCodeMax: "", //最大金额字段名
        },
     */
    this.fields.forEach((element) => {
      if (element.fieldType === 'SELECT' || element.fieldType === 'CASCADER') {
        const params = {
          dictClassCode: element.fieldDictClass,
          dictItemCode: element.fieldDictItem != 'undefined' ? element.fieldDictItem : ''
        };
        let option = [];
        if (element.fieldDictClass) {
          if (element.fieldDictApi && element.fieldDictApi === 'tenant') {

          } else {

          }
          element.selectOptions = option;
        }
      }
    });
  },
  updated() {},
  destroyed() {},
  methods: {
    handleClickShowMore() {
      this.showMore = !this.showMore;
    },
    submitForm() {
      /**
       * 提交查询时默认值空字符串转成null
       */
      for (let key in this.ruleForm) {
        if (this.ruleForm[key] === '') {
          this.ruleForm[key] = null;
        }
      }

      let isResolve = false; //是否特殊处理后提交
      // let commitForm = JSON.parse(JSON.stringify(this.ruleForm));
      let commitForm = {
        ...this.ruleForm
      };
      this.fields.forEach((element) => {
        //处理日期范围选择框
        if (
          element.fieldType === 'DATE_RANGE' &&
          typeof element.fieldCodeStart != 'undefined' &&
          typeof element.fieldCodeEnd != 'undefined'
        ) {
          isResolve = true;
          if (this.isNotNull(this.ruleForm[element.fieldCode])) {
            commitForm[element.fieldCodeStart] = this.ruleForm[element.fieldCode][0];
            commitForm[element.fieldCodeEnd] = this.ruleForm[element.fieldCode][1];
          } else {
            commitForm[element.fieldCodeStart] = null;
            commitForm[element.fieldCodeEnd] = null;
          }
          commitForm[element.fieldCode] = null;
          delete commitForm[element.fieldCode];
        }
      });
      if (isResolve) {
        // console.log('commitForm=========' + JSON.stringify(commitForm));
        this.$emit('submitForm', commitForm);
      } else {
        this.$emit('submitForm', this.ruleForm);
      }
    },
    // 重置
    resetQuery() {
      this.resetForm('ruleForm');
      resetForm(this.ruleForm);
      this.$emit('submitForm', {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 在需要时触发el-select点击事件,property对应多个select
     */
    selectClickHandle(flag, property) {
      if (flag) {
        this.$emit('selectClick', property);
      }
    },
    /**
     * 在需要时触发el-select value改变事件,property对应多个select
     */
    changeHandle(property) {
      this.$emit('changeValue', property);
    },
    handleSelect() {
      this.$emit('autocompleteSelect');
    },
    cascaderChange(val,ref){
      this.$emit('cascaderChange',(this.$refs[ref])[0].getCheckedNodes()[0]?(this.$refs[ref])[0].getCheckedNodes()[0].data:null)
    }
  }
};
</script>

<style scoped lang="scss">
// @import "../../styles/common/main.scss";
.demo-ruleForm {
  -js-display: flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.el-input {
  display: block !important;
  height: 32px !important;
  line-height: 32px !important;
}
.el-select {
  display: block !important;
  height: 32px !important;
  line-height: 32px !important;
}
.el-date-editor {
  height: 40px !important;
  line-height: 40px !important;
}
::v-deep .el-range-editor--medium .el-range-input {
  font-size: 14px !important;
  height: 28px !important;
  line-height: 28px !important;
}

.el-form-item {
  margin-bottom: 10px;
}

.right-content {
  min-width: 230px;
  .btn-group {
    // @include clearfix();
    float: right;
    margin-left: 5px;
    .show-more {
      color: #00b39b;
      font-size: 14px;
      margin-left: 5px;
    }
  }
}

.price-row {
  .price-input {
    position: relative;
    .price-font {
      position: absolute;
      font-style: normal !important;
      margin-left: -15px !important;
      margin-top: 5px !important;
    }
  }

  .price-split {
    text-align: center !important;
  }
}

.date-range .el-range-separator {
  width: 20px !important;
}
.form-item {
  min-height: 52px; //IE栅格布局换行错位的处理
}
</style>  



// WEBPACK FOOTER //
// src/components/QueryForm/index.vue